module.exports = {
	"id": "CL",
	"name": "Chile",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012582,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012582,
			"19": null,
			"20": null,
			"21": 0.006291,
			"22": 0.06291,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.031455,
			"27": 0.012582,
			"28": null,
			"29": 0.006291,
			"30": null,
			"31": 0.031455,
			"32": 0.006291,
			"33": 0.018873,
			"34": 0.044037,
			"35": 0.031455,
			"36": 0.044037,
			"37": 0.037746,
			"38": 0.06291,
			"39": 0.056619,
			"40": 0.025164,
			"41": 0.037746,
			"42": 0.025164,
			"43": 0.144693,
			"44": 0.069201,
			"45": 0.050328,
			"46": 0.113238,
			"47": 0.094365,
			"48": 0.113238,
			"49": 2.289924,
			"50": 0.169857,
			"51": 0.69201,
			"52": 0.647973,
			"53": 32.134428,
			"54": 7.995861,
			"55": 0.050328,
			"56": 0.012582,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006291,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.006291,
			"32": null,
			"33": null,
			"34": 0.012582,
			"35": null,
			"36": 0.006291,
			"37": 0.012582,
			"38": 0.031455,
			"39": 0.031455,
			"40": 0.012582,
			"41": 0.031455,
			"42": 0.031455,
			"43": 0.069201,
			"44": 0.025164,
			"45": 0.081783,
			"46": 0.037746,
			"47": 0.295677,
			"48": 0.364878,
			"49": 4.126896,
			"50": 0.018873,
			"51": 0.006291,
			"52": null,
			"3.5": null,
			"3.6": 0.012582
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.018873,
			"37": 0.025164,
			"38": 0.025164,
			"39": 0.012582,
			"40": 0.478116,
			"41": 0.075492,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.018873
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.018873,
			"6": 0.018873,
			"7": 0.031455,
			"8": 0.195021,
			"9": 0.207603,
			"10": 1.082052,
			"3.1": null,
			"3.2": null,
			"5.1": 0.044037,
			"6.1": 0.037746,
			"7.1": 0.012582,
			"9.1": 0.81783
		},
		"ios_saf": {
			"8": 0,
			"10": 3.90968129725,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.105361386969,
			"8.1-8.4": 0.19465069796,
			"9.0-9.2": 0.0928608834305,
			"9.3": 1.41672373439
		},
		"android": {
			"3": 0,
			"4": 0.0441438087855,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00551797609819,
			"4.1": 0.159233024548,
			"4.2-4.3": 0.39808256137,
			"4.4": 0.912830903101,
			"4.4.3-4.4.4": 0.920713726098
		},
		"ie": {
			"6": 0.0191373277311,
			"7": 0.0063791092437,
			"8": 0.210510605042,
			"9": 0.216889714286,
			"10": 0.146719512605,
			"11": 1.67770573109,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0260898100196,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000724716944988
		},
		"edge": {
			"12": 0.069201,
			"13": 0.301968,
			"14": 0.597645
		},
		"ie_mob": {
			"10": 0.0672843943662,
			"11": 0.273943605634
		},
		"bb": {
			"7": 0.007418,
			"10": null
		},
		"samsung": {
			"0": 1.305568
		},
		"and_uc": {
			"0": 0.11127
		},
		"op_mini": {
			"0": 0.351503473035
		},
		"and_chr": {
			"0": 30.933336
		},
		"and_ff": {
			"0": 0.022254
		}
	},
	"total": 97.99143
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CL.json
 ** module id = 496
 ** module chunks = 0
 **/